import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useGetDoctypeDetailsQuery, useGetDoctypeitemQuery, useLazyGetDoctypeitemQuery,useGetdocnameQuery } from "../../../../store/api/address";

const Table = ({ apidata, setSelectedCompanyAccounts, companyAccounts }) => {

    const [company, setCompany] = useState([]);
    const [linkNames, setLinkNames] = useState([]);
    const [items, setItems] = useState([]);
    const [docktype, setDocktype] = useState('');


    const createInitialRows = () => {
        if (apidata?.links?.length > 0) {
            return apidata.links.map(item => ({
                company: item.link_doctype,
                link_name: item.link_name
            }));
        }
        return [createNewRow()];
    };

    const createNewRow = () => ({
        company: "",
        link_name: ""
    });

    const [doctype, setDoctype] = useState('');
    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [rows, setRows] = useState(createInitialRows());
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
    const [triggerDoctypeitem] = useLazyGetDoctypeitemQuery();
    const { data: companyData } = useGetdocnameQuery();

    useEffect(() => {
        if (companyData) {
            setCompany(companyData?.data || []);
        }
    }, [companyData]);

    useEffect(() => {
        if (apidata?.links) {
            const newRows = apidata.links.map(item => ({
                company: item.link_doctype,
                link_name: item.link_name
            }));
            if (JSON.stringify(newRows) !== JSON.stringify(rows)) {
                setRows(newRows);
            }
        }
    }, [apidata]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const toggleRowSelection = (index) => {
        setSelectedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const updateRow = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        setRows([...rows, createNewRow()]);
        const lastPage = Math.ceil((rows.length + 1) / rowsPerPage);
        if (currentPage !== lastPage) setCurrentPage(lastPage);
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) setCurrentPage(lastPage);
    };

    const handleSelect = async (rowIndex, field, selectedItem) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex][field] = selectedItem.name;
        setRows(updatedRows);
        setShowDropdownIndex(null);
        setDocktype(selectedItem.name);

        if (field === 'company') {
            try {
                const result = await triggerDoctypeitem(selectedItem.name).unwrap();
                setLinkNames(result.data);
            } catch (error) {
                console.error("Failed to fetch doctype data:", error);
            }
        }
    };

    useEffect(() => {
        const filtered = rows
            .filter(row => row.company && row.link_name)
            .map(row => ({
                link_doctype: row.company,
                link_name: row.link_name
            }));

        setSelectedCompanyAccounts(filtered);
    }, [rows]);

    return (
        <div className="table-container">
            <table className="table table-bordered mb-1" ref={tableRef}>
                <thead className="tableHead1">
                    <tr>
                        <th style={{ width: '4%', textAlign: 'center' }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                style={{
                                    backgroundColor: isAllSelected ? "#270b79" : "",
                                    borderColor: isAllSelected ? "#270b79" : ""
                                }}
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                            />
                        </th>
                        <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
                        <th style={{ width: '350px' }}>Link Document Type</th>
                        <th style={{ width: '350px' }}>Link Name</th>
                        <th style={{ width: '250px', textAlign: 'center' }}>
                            <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((row, index) => {
                        const globalIndex = indexOfFirstRow + index;
                        const showCompanyDropdown = showDropdownIndex === globalIndex && focusedCell.field === 'company';
                        const showLinkNameDropdown = showDropdownIndex === globalIndex && focusedCell.field === 'link_name';

                        return (
                            <tr key={globalIndex} style={{ height: '30px' }}>
                                <td className="p-0" style={{ cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        style={{
                                            backgroundColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                                            borderColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                                            marginTop: '8px'
                                        }}
                                        checked={selectedRows.includes(globalIndex)}
                                        onChange={() => toggleRowSelection(globalIndex)}
                                    />
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    <span style={{ fontSize: '0.8rem' }}>{globalIndex + 1}</span>
                                </td>
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        className="form-control tableinput noborder"
                                        value={row.company}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'company' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "company", e.target.value)}
                                    />
                                    {showCompanyDropdown && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {company
                                                .filter(c => c.name.toLowerCase().includes(row.company?.toLowerCase()))
                                                .map((comp) => (
                                                    <button
                                                        key={comp.id}
                                                        className="dropdown-item"
                                                         style={{ fontSize: '0.8rem' }}
                                                        type="button"
                                                        onClick={() => handleSelect(globalIndex, 'company', comp)}
                                                    >
                                                        {comp.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        className="form-control tableinput noborder"
                                        value={row.link_name}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'link_name' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "link_name", e.target.value)}
                                    />
                                    {showLinkNameDropdown && (
                                        <div
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {linkNames.length === 0 ||
                                                linkNames.filter(ln => ln.name.toLowerCase().includes(row.link_name?.toLowerCase())).length === 0 ? (
                                                <div className="dropdown-item disabled text-center" style={{ color: '#999' }}>
                                                    No items found
                                                </div>
                                            ) : (
                                                linkNames
                                                    .filter(ln => ln.name.toLowerCase().includes(row.link_name?.toLowerCase()))
                                                    .map((linkName) => (
                                                        <button
                                                            key={linkName.id}
                                                            className="dropdown-item"
                                                             style={{ fontSize: '0.8rem' }}
                                                            type="button"
                                                            onClick={() => handleSelect(globalIndex, 'link_name', linkName)}
                                                        >
                                                            {linkName.name}
                                                        </button>
                                                    ))
                                            )}
                                        </div>
                                    )}
                                </td>
                                <td className="p-0">
                                    <GetIcon iconName="MdOutlineEdit" size={13} style={{ marginTop: '5px' }} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="d-flex pb-2 justify-content-between align-items-center">
                <div className="d-flex" style={{ gap: '4px' }}>
                    {selectedRows.length > 0 && (
                        <Button
                            onClick={handleDeleteSelectedRows}
                            className="customdeletebtn"
                            iconName="MdDeleteOutline"
                        >
                            Delete
                        </Button>
                    )}
                    <Button
                        onClick={handleAddRow}
                        className="Addrowdesign"
                        iconName="FiPlus"
                        iconWrapperStyle={{ backgroundColor: '#ff8d5c' }}
                    >
                        Add Row
                    </Button>
                    <Button
                        className="createbtn d-flex"
                        iconName="MdOutlineFileDownload"
                        style={{ height: '28px' }}
                    >
                        Download
                    </Button>
                </div>
                {rows.length > 10 && (
                    <>
                        <div className="d-flex align-items-center centerpagination">
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                pageSize={rowsPerPage}
                                totalrecords={rows.length}
                            />
                        </div>
                        <div className="d-flex">
                            <span className="px-2" style={{ color: '#270B79' }}>
                                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Table;